<template>
  <div class="team-card d-flex flex-column align-center">
    <v-img :src="parsedImg" class="rounded-xl team-img" />
    <h3 class="mt-3">{{ item.title }}</h3>
    <h4 class="secondary--text">{{ item.role }}</h4>
  </div>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    parsedImg() {
      let img = !this.item.img ? DefaultImg : this.files + this.item.img;

      const width = 390;

      return `${img}?resize=1&w=${width}`;
    },
  },
};
</script>

<style lang="scss">
.team-card {
  .team-img {
    aspect-ratio: 1/1;
    object-fit: cover;
    width: 250px;
    max-width: 100%;
  }
  h3 {
    font-size: 18px;
    font-weight: 500;
  }
  h4 {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
